<template>
    <div class="accessIndex">
      <section class="dashboard__by_date">
        <p class="dashboard__general--title">Usuarios (Generación de pin)</p>
        <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
          <v-layout
            v-if="fase==0"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs2>
            </v-flex>
            <v-flex xs8 style="">
              <v-text-field
                v-model="rut"
                style="margin-top:30px"
                label="Cédula"
                required
                placeholder="Cédula"
                @keypress="isRutValid($event)"
                :rules="[rules.required, rules.affair,rules.rut]"
                counter="20">
              </v-text-field>
            </v-flex>

            <v-flex xs4  style="margin-left:33%!important">
              <v-btn
                type="button"
                outline
                color="#353545"
                style="width: 100%;margin-top:20px; "
                @click="checkRut()"
                :disabled="!valid || !rut">
                Generar Pin
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout
            v-else-if="fase==1"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Estado del proceso:</b>
              </p>
              <p style="text-align:center;font-size:20px;margin-top:20px">
               <b> <i>{{fase1Status}}</i>  </b>
              </p>
              <p style="text-align:center;font-size:15px">
                <i>Hacer click en iniciar lector. (Servicio en segundo plano ejecutándose)</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:0%"
            @click="closeSignUpFingerprint();newPin();"
            >Regresar</v-btn>
          </v-flex>
          </v-layout>
          <v-layout
            v-else-if="fase==2"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Estado del proceso:</b>
              </p>
              <p style="text-align:center;font-size:20px;margin-top:20px">
               <b> <i>{{fase2Status}}</i>  </b>
              </p>
              <p style="text-align:center;font-size:15px">
                <i>Hacer click en iniciar lector. (Servicio en segundo plano ejecutándose)</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:0%"
            @click="closeValidateFingerprint();newPin()"
            >Regresar</v-btn>
          </v-flex>
          </v-layout>
          <v-layout
            v-else-if="fase==3"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Pin de ingreso:</b>
              </p>
              <p style="margin-top:20px;text-align:center;font-size:30px">
                <i>{{pin}}</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:40%"
            @click="newPin()"
            >Continuar</v-btn>
          </v-flex>
          </v-layout>
          <v-layout
            v-else-if="fase==-1"
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Pin de ingreso:</b>
              </p>
              <p style="margin-top:20px;text-align:center;font-size:15px">
                <i>{{myError}}</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:40%"
            @click="newPin()"
            >Continuar</v-btn>
          </v-flex>
          </v-layout>
          <v-layout
            v-else
            row
            wrap
            style="background-color: #fff; padding: 20px;margin-top:20px">  
            <v-flex xs12>
              <p style="margin-bottom:20px">
                <b>Pin de ingreso:</b>
              </p>
              <p style="margin-top:20px;text-align:center;font-size:30px">
                <i>{{pin}}</i>  
              </p>
            </v-flex>
          <v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex;">
            <v-btn
            outline
            color="red"
            style="width: 20%; margin-left:40%"
            @click="newPin()"
            >Continuar</v-btn>
          </v-flex>
          </v-layout>
        </v-form>
    </section>
    </div>
</template>

<script>
import md5 from 'js-md5';
import extra from './../../../../vue/additionalData/mixData.js';
export default {
  data(){
    return{
      rut:'',
      pin:[],
      rules: {
          required: value => (value&&value.length>0) || 'Este campo es obligatorio',
          affair: value => value.length <= 20 || 'Máximo 20 caracteres',
          rut: value => {
                if(value.length >20){return 'El rut no debe tener más de 20 caracteres' }else if(value.length > 6) {return !isNaN(value.substring(0,value.length-1)) || 'Formato de Rut incorrecto'}else{return 'El Rut debe tener al menos 7 caracteres'}},
      },
      valid: false,
      fase:0,
      faseError:0,
      myError:'',
      fase1Status:'Registrando huella de usuario',
      fase2Status:'Validando huella de usuario'
    }
  },

  methods:{
    isRutValid(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && evt.key.toUpperCase()!="K") {
            evt.preventDefault();;
        } else {
            return true;
        }
    }, 


    async checkRut(){
     
      let code=await this.$localforage.df5c729d64ed93b36cbbbff41f179.getItem(md5(this.rut));
      if(code){
        let isFingerprintActive= await this.checkFingerprint(this.rut);
        console.log("SENDING",isFingerprintActive)
        if(isFingerprintActive){
          this.fase=2;
          this.openCompareFingerprint(this.decrypt_info(code).q_tok);            
        }else{
          this.fase=-1;
          this.faseError=0;
          this.myError="El usuario no tiene una huella registrada, no hay internet para registarla";
        }            
      }else{       
        this.fase=-1;
        this.faseError=0;
        this.myError="No se pudo encontrar ningún usuario con ese rut";
      }
    },

    newPin(){
      this.rut=''
      this.pin=[]
      this.fase=0;
      this.faseError=0;
      this.fase1Status='Registrando huella de usuario';
      this.myError="";      
    },
    
    generatePin(){
      var self=this;
      try {
        this.$http.get('get_user_pin',{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          },
          params:{
            location_id: localStorage.getItem("location_id"),
            rut:self.rut
          }
        })
        .then(function(response){
          self.pin = response.body.data
          // self.isInError=response.body.error
          self.fase=3;
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
       self.updateAlertMessage(e.message)
       self.updateIsInAlert(true) 
      }      
    },
    checkFingerprint(rut){
      var ans=false;
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }
      var filePathFingerpint=filePath+"Fingerprints/A_"+md5(rut)+".fpt"      
      try {
        if (fs.existsSync(filePathFingerpint)){
          var myCompareFile= fs.createWriteStream(filePath+"Name_to_match.txt")
          myCompareFile.write("A_"+md5(rut))
          myCompareFile.end()
          myCompareFile.on('error', function (err) {
            myCompareFile.end();            
          });
          ans=true;
        }
      } catch(err) {
        console.error(err)
      }
      return ans
      
    },
    openSignUpFingerprint(){
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }

      var filePathReg=filePath+"Enrollment_Control.txt"
      var writeStream = fs.createWriteStream(filePathReg);
      writeStream.on('error', function (err) {
        console.log(err);
      });
      writeStream.write("1");
      writeStream.end();
      this.waitFingerprintResponse(fs)
    },
    async closeSignUpFingerprint(){
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }

      var filePathReg=filePath+"Enrollment_Control.txt"
      var writeStream2 = fs.createWriteStream(filePathReg);
      writeStream2.on('error', function (err) {
        console.log(err);
      });
      writeStream2.write("0");
      writeStream2.end();
    },
    async closeValidateFingerprint(){
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }

      var filePathReg=filePath+"Verification_Control.txt"
      var writeStream3 = fs.createWriteStream(filePathReg);
      writeStream3.on('error', function (err) {
        console.log(err);
      });
      writeStream3.write("0");
      writeStream3.end();
    },
    async waitFingerprintResponse(fs){
      var vm = this
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }
      var filePathControl=filePath+"Enrollment_Status.txt"
      var filePathFingerpint=filePath+"Fingerprints/A_.fpt"
      await new Promise(function(resolve, reject) {
        var fsWait = false;
        var watcher=fs.watch(filePathControl, async (event, filename) => {
          try{
            if (filename) {
              if (fsWait) return;
              fsWait = setTimeout(() => {
                fsWait = false;
              }, 100);
              var a= fs.readFileSync(filePathControl)
              // console.log(`${filename} file Changed`);
              if(a.toString()!=0){
                // console.log("CAMBIO:",a.toString())
                if(a.toString()==1){
                  var r_finger= await fs.readFileSync(filePathFingerpint)
                  // console.log("MY DOCUMENT")
                  // console.log(r_finger)
                  // var fileFinger=new File(r_finger, "A_.fpt" );   
                  var fileFinger = new Blob([r_finger], {type:'text/plain;charset=UTF-16LE;'});               
                  var my_fingerprint=null
                  var reader= new FileReader()
                  reader.readAsDataURL(fileFinger);
                  reader.onload = async function(){
                    my_fingerprint=reader.result;
                    var myData={
                      attributes:{  
                        rut: vm.rut,
                        encrypted_code: my_fingerprint
                      }
                    }
                    // console.log(my_fingerprint)
                    // console.log(myData)
                    vm.fase1Status='Enviando huella al servidor...'
                    await vm.sendFingerPrint(myData,vm)    
                  }                             
                }else{
                  this.updateAlertMessage("Error al registrar la huella, vuelva a intentarlo")
                  this.updateIsInAlert(true)
                }           
                
                watcher.close()
                resolve()
              }
            
            }
          }catch(e){ watcher.close();console.log(e);reject()} 
        });
      });
    },
    openCompareFingerprint(q_tok){
      var fs=window.require("fs")
      if (!fs) {
        alert('The File APIs are not fully supported in this browser.');
      }
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }
      let filePathControl=filePath+"Verification_Control.txt"
      var writeStream = fs.createWriteStream(filePathControl);
      writeStream.on('error', function (err) {
        console.log(err);
      });
      writeStream.write("1");
      writeStream.end();
      
      this.waitFingerprintComparation(fs,q_tok)
    },
    downloadFingerprint(fingerprint,rut){
      return new Promise(function(resolve, reject) {
        var fs=window.require("fs");
        var http = require('http');
        if (!fs) {
          alert('The File APIs are not fully supported in this browser.');
        }
        var filePath= localStorage.getItem("fingerprint_API_env")
        if(!filePath){
          filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
        }
        var myDest=filePath+"Fingerprints/A_"+md5(rut)+".fpt"
        var myFingerFile = fs.createWriteStream(myDest);
        myFingerFile.on('error', function (err) {
          myFingerFile.end();
          fs.unlink(myDest); // Delete the file async. (But we don't check the result)
          reject()
        });
        var myCompareFile= fs.createWriteStream(filePath+"Name_to_match.txt")
        myCompareFile.write("A_"+md5(rut))
        myCompareFile.end()
        myCompareFile.on('error', function (err) {
          myCompareFile.end();
          reject()
          fs.unlink(myDest); // Delete the file async. (But we don't check the result)          
        });
     
        var value=fingerprint
        // var value8=b64_to_utf8(value)    
        console.log("HUELLA")
        console.log(value)
        var myTest=new Uint16Array(value)
        console.log(myTest)
        // function bin2String(array) {
        //   var result = "";
        //   for (var i = 0; i < array.length; i++) {
        //     result += array.charCodeAt(array[i]);
        //   }
        //   return result;
        // }
        var myStr=String.fromCharCode.apply(null, myTest);
        fs.writeFile(myDest, myStr,"utf-16LE", (err) => {
          if (err) throw err;
          console.log('The file has been saved!');
          resolve()
        });
        // resolve()
  //       var si=new ArrayBuffer(value);
  //       var no = new Uint16Array(si);
  //       // var no=strEncodeUTF16(si)
  //       // console.log(no)      
  //       var blob=new Blob(,{type:'charset=UTF-16LE;'});
  //       // var url= URL.createObjectURL(blob)
  //       // console.log(url)
  //         var uint8array = new TextEncoder().encode(string);
  // var string = new TextDecoder(encoding).decode(uint8array);
  //       const reader = new FileReader();
  //       reader.addEventListener('loadend', (e) => {
  //         console.log(e)
  //         var  text = e.srcElement.result;
  //         console.log(text);
  //         console.log("HUELLA FINAL")
  //         // console.log(myValue)
  //         fs.writeFile(myDest, text,"utf-16LE", (err) => {
  //           if (err) throw err;
  //           console.log('The file has been saved!');
  //           resolve()
  //         });               
  //       });

  //       // Start reading the blob as text.
  //       reader.readAsArrayBuffer(blob);
        // var buff= new Uint16Array(value);
        // console.log(buff)
        // var enc = new TextDecoder("utf-16le");
        // console.log(enc.decode(buff));
        // var bb= enc.decode(buff)
        
        // console.log("LOLAZO")
        // console.log(superAns)
        // let myValue= decodeUTF16LE( value8 )
        // fs.writeFile(myDest, bb, (err) => {
        //   if (err) throw err;
        //   console.log('The file has been saved!');
           
        // });
        
        function strEncodeUTF16(str) {
          var buf = new ArrayBuffer(str.length*2);
          var bufView = new Uint16Array(buf);
          for (var i=0, strLen=str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
          }
          return bufView;
        }

        // function b64_to_utf8( str ) {
        //   return decodeURIComponent(escape(window.atob( str )));
        // }
        // function decodeUTF16LE( text ) {
        //     var byteArray = new Uint8Array(text.length * 2);
        //     for (var i = 0; i < text.length; i++) {
        //         byteArray[i*2] = text.charCodeAt(i) // & 0xff;
        //         byteArray[i*2+1] = text.charCodeAt(i) >> 8 // & 0xff;
        //     }
        //     return String.fromCharCode.apply( String, byteArray );
        // }
       
      })
    },
    async waitFingerprintComparation(fs,q_tok){
      var vm = this
      var filePath= localStorage.getItem("fingerprint_API_env")
      if(!filePath){
        filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
      }
      var filePathControl=filePath+"Verification_Status.txt"

      await new Promise(function(resolve, reject) {
        var fsWait = false;
        var ansWatcher=fs.watch(filePathControl, async (event, filename) => {
          try{
            if (filename) {
              if (fsWait) return;
              fsWait = setTimeout(() => {
                fsWait = false;
              }, 100);
              var a= fs.readFileSync(filePathControl)
              // console.log(`${filename} file Changed`);
              if(a.toString()!=0){
                // console.log("CAMBIÓ A:",a.toString())
                
                if(a.toString()==1){                  
                  vm.getSomeNeko(vm.rut,q_tok)                
                }else if(a.toString()==2){
                  vm.fase=-1
                  vm.faseError=2;
                  vm.myError="La huella ingresada no corresponde a la de este usuario"                                                 
                }else if(a.toString()==-1){
                  vm.fase=-1
                  vm.faseError=2;
                  vm.myError="Error en el aplicativo de huella, reíntente por favor."                                    
                }else{
                  console.log("VALOR INCORRECTO REVISE EL APLICATIVO")
                }                           
                ansWatcher.close()
                resolve()
              }
            
            }
          }catch(e){ console.log(e);ansWatcher.close();reject()} 
        });
      });
    },
    sendFingerPrint(fingerprint,vm){  
      
      return new Promise(function(resolve, reject) {
        try {  
          console.log(fingerprint)        
          vm.$http.post('fingerprints',{
            data: vm.encrypt(fingerprint).toString()
          },{
            headers: {
              "X-Device-ID" : vm.getDeviceId(),
              "Authorization" : 'Bearer ' + vm.getUserToken()
            }
          }).then(function(response){
            // console.log("FUNCIONAAAA")
            // console.log(response)  
            vm.checkRut()   
            if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
            resolve()
          }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            console.log("ERROR EN PETICIÓN")
            console.log(response);
            vm.fase=-1
            self.faseError=1;
            self.myError="Error en el envío de la huella";
            reject()

          })
        } catch (e) {
          console.log("ERROR EN PETICIÓN")
          console.log(e)
          vm.fase=-1
          self.faseError=1;
          self.myError="Error en el envío de la huella";
          reject()

        }
      })
    },

    async getSomeNeko(code,t){
      let m= new Date()
      m.setHours(m.getHours()-4)
      var numberPins=4
      var mm=[]
      let month=  (m.getUTCMonth()+1).toString().length==2? (m.getUTCMonth()+1):'0'+(m.getUTCMonth()+1)
      let day=  m.getUTCDate().toString().length==2? m.getUTCDate():'0'+m.getUTCDate()
      let date= m.getUTCFullYear() + month + day
      // console.log("KEY",process.env)
      console.log(process)
      console.log(window.process)
      
      var codeN= md5(extra.myData3()+md5(code)+date) 
      for(let n=0; n<numberPins; n++ ){
        mm.push(this.trasduct(codeN))
        codeN= md5(codeN)
      }
      let iteration= await this.$localforage.cj47054b89dc6c1f821c6e38d.getItem(md5(this.rut));
      if(iteration==null || iteration.d27e82d67f4f6511f7f!=date|| iteration.ff2b2e95569f56de68615df==numberPins){
        iteration={d27e82d67f4f6511f7f: date,ff2b2e95569f56de68615df:1}
      }else{
        iteration.ff2b2e95569f56de68615df=iteration.ff2b2e95569f56de68615df+1
      }
      this.$localforage.cj47054b89dc6c1f821c6e38d.setItem(md5(this.rut),iteration)
      let finalValue=iteration.ff2b2e95569f56de68615df+t
      if(finalValue>numberPins){
        finalValue=1
      }
      
      this.pin = mm[finalValue-1]
      this.fase=3;       
    },    
  
    trasduct(argString){
      var word=''
      var myString=extra.rr(argString);
      let pickNumber=true
      for(let digit in myString){
        if(Number(myString[digit])||Number(myString[digit])==0){
          if(pickNumber){
            if(word.length<4){
              word=word.toString()+myString[digit]; 
              pickNumber=false;
            }else{
              return word
            }
          }else{
            pickNumber=true
          }
        }
      }
      while(word.length<4){
        word=word.toString()+"9";
      }
      return word
    }


  },
  created(){
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/OfflineCounter.vue